import { addHours, format } from 'date-fns'

export type GanttDaySegment = {
  id: string
  date: Date
  hours: Date[]
}

export type GanttMonthSegment = {
  id: string
  date: Date
  columns: number
}

export const buildGanttDaySegments = (
  datetimeStart: Date,
  datetimeEnd: Date
): GanttDaySegment[] => {
  const segments: GanttDaySegment[] = []

  let current = datetimeStart
  while (current <= datetimeEnd) {
    const id = format(current, 'dd.MM.yyyy')
    const lastSegment = segments[segments.length - 1]

    if (!lastSegment || lastSegment.id !== id) {
      segments.push({
        id,
        date: current,
        hours: [current],
      })
    } else {
      lastSegment.hours.push(current)
    }

    current = addHours(current, 1)
  }

  return segments
}

export const buildGanttMonthSegments = (
  daySegments: GanttDaySegment[]
): GanttMonthSegment[] => {
  const segments: GanttMonthSegment[] = []

  for (const daySegment of daySegments) {
    const id = format(daySegment.date, 'MM.yyyy')
    const lastSegment = segments[segments.length - 1]

    if (!lastSegment || lastSegment.id !== id) {
      segments.push({
        id,
        date: daySegment.date,
        columns: daySegment.hours.length,
      })
    } else {
      lastSegment.columns += daySegment.hours.length
    }
  }

  return segments
}
